export enum ProductSource {
  BANKING = 'banking',
  ACCOUNTING = 'accounting',
}
